import React, { useState, useCallback, useRef, useMemo, useEffect } from 'react';

var hiddenStyles = {
  display: 'none'
};
function HiddenText(_ref) {
  var id = _ref.id,
      value = _ref.value;
  return React.createElement("div", {
    id: id,
    style: hiddenStyles
  }, value);
}

var visuallyHidden = {
  position: 'absolute',
  width: 1,
  height: 1,
  margin: -1,
  border: 0,
  padding: 0,
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(100%)'
};
function LiveRegion(_ref) {
  var id = _ref.id,
      entries = _ref.entries;
  return React.createElement("div", {
    id: id,
    style: visuallyHidden,
    "aria-live": "assertive",
    "aria-relevant": "additions",
    "aria-atomic": true
  }, entries.map(function (_ref2) {
    var id = _ref2[0],
        entry = _ref2[1];
    return React.createElement("span", {
      key: id.toString()
    }, entry);
  }));
}

var timeout = 1e3; // 1 second

function useAnnouncement() {
  var _useState = useState(new Map()),
      announcementMap = _useState[0],
      setAnnouncements = _useState[1];

  var announce = useCallback(function (announcement) {
    setAnnouncements(function (announcements) {
      var timeoutId = setTimeout(function () {
        setAnnouncements(function (announcements) {
          announcements["delete"](timeoutId);
          return new Map(announcements);
        });
      }, timeout);
      announcements.set(timeoutId, announcement);
      return new Map(announcements);
    });
  }, []);
  var announcementMapRef = useRef(announcementMap);
  var entries = useMemo(function () {
    return Array.from(announcementMap.entries());
  }, [announcementMap]);
  useEffect(function () {
    announcementMapRef.current = announcementMap;
  }, [announcementMap]);
  useEffect(function () {
    return function () {
      // Clean up any queued `setTimeout` calls on unmount
      // eslint-disable-next-line react-hooks/exhaustive-deps
      announcementMapRef.current.forEach(function (_, key) {
        clearTimeout(key);
      });
    };
  }, []);
  return {
    announce: announce,
    entries: entries
  };
}

export { HiddenText, LiveRegion, useAnnouncement };
//# sourceMappingURL=accessibility.esm.js.map
